import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { comics } from '@/mocks/comics';

export default function FeaturedComics() {
  const { t } = useTranslation();
  const featured = comics.slice(0, 6);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            {t('home.featured_title')}
          </h2>
          <p className="text-sm text-foreground-600">{t('home.featured_subtitle')}</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {featured.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group cursor-pointer no-underline"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4]">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 抖漫网页版在线免费阅读`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <span className="text-white text-xs font-medium">{t('home.read_now')}</span>
                </div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-[10px] font-semibold rounded-full">
                    {comic.rating}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}